import { render, staticRenderFns } from "./History.vue?vue&type=template&id=649302dc&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"
import style0 from "./History.vue?vue&type=style&index=0&id=649302dc&prod&lang=css"
import style1 from "./History.vue?vue&type=style&index=1&id=649302dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649302dc",
  null
  
)

export default component.exports